import React from 'react'
import ReactDOM from 'react-dom/client'
import Privacy from './components/Privacy'
import './handu.css'

ReactDOM.createRoot(document.getElementById('root')).render(
  <React.StrictMode>
    <Privacy />
  </React.StrictMode>,
)
